<script setup lang="ts">
import { MaybeRef } from 'vue'
import { TableStats } from '../../../types/stats'
import PejerGraph from '../PejerGraph.vue'
defineProps<{
  data: MaybeRef<TableStats<any>[]>
}>()
</script>
<template>
  <PejerGraph
    :data="data"
    is-bar
    :data-options="[
      {
        key: 'count',
        name: 'Created',
        color: '#13b982',
      },
    ]"
  />
</template>
